import { ChangeDetectorRef, Component, OnInit, Inject, ViewChild, ElementRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from '../../admin.service';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import * as htmlToImage from 'html-to-image';
import { FormControl } from '@angular/forms';
import html2canvas from 'html2canvas';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-competition-entry',
  templateUrl: './competition-entry.component.html',
  styleUrls: ['./competition-entry.component.css']
})



export class CompetitionEntry implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  competitionId = "";
  status = "";
  allEntries: any;
  offset = 0;
  totalEntries = 9;
  entryStatus = "PENDING"
  rejectedCompetition = 0;
  pendingCompetition = 0;
  approvedCompetition = 0;
  scheduleCompetition = 0;
  competitionDetail: any;
  previewEntry: any;
  emptySvgurl = 'assets/no-entry.svg';
  previewImageNumber = 0;
  previewImageIndex = 0;
  labels = [];
  paginationLength = 0;
  resultDeclared;
  selectWinner = false;
  selectedStateFilterName = "All State";
  selectedStateFilterCode = "all_states";
  filterStates = [{ name: "All States", code: "all_states" }];
  filterClass = [{ name: "All Class", value: "all_class" }]
  selectedClassFilterCode = "all_class";
  isMultipleSelectOn = false;
  selectedEntry = [];
  selectedWinnerSubmissionIds = []
  hasCompetitionZoneAccess: boolean = false;
  hasPostHubAccess: boolean = false;
  ngOnInit(): void {
    const adminFeatureList = sessionStorage.getItem('adminFeatureList');
    if (adminFeatureList) {
      const features = JSON.parse(adminFeatureList);
      this.hasCompetitionZoneAccess = features.includes('competitions');
      this.hasPostHubAccess = features.includes('posts');
    }
    this.offset = 0;
    this.competitionId = this.activatedRoute.snapshot.params.competitionUUID;
    this.status = this.activatedRoute.snapshot.params.status;
    this.resultDeclared = this.activatedRoute.snapshot.params.result;
    this.getCompetitionDetails();
    this.getCompetitionEntries();
    this.makeLabelsForEntry();
    this.triggerFillterButton(1);
  }
  constructor(private adminService: AdminService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private _matDialog: MatDialog, private _snackBar: MatSnackBar) { }

  getCompetitionDetails() {
    this.adminService.getCompetitionDetails(this.competitionId).subscribe(
      (res) => {
        this.competitionDetail = res.body.competition;
        this.competitionDetail?.submission_status_count.forEach(item => {
          switch (item.status) {
            case 'REJECTED':
              this.rejectedCompetition = item.count;
              break;
            case 'PENDING':
              this.pendingCompetition = item.count;
              break;
            case 'APPROVED':
              this.approvedCompetition = item.count;
              break;
            case 'SHORTLISTED':
              this.scheduleCompetition = item.count;
              break;
            default:
              break;
          }
          this.approvedCompetition = this.competitionDetail?.submission_count - (this.rejectedCompetition + this.pendingCompetition + this.scheduleCompetition);

        });
      })
  }
  reInitialize(){
    if(this.isMultipleSelectOn === false){
      this.selectedEntry = [];
    }
  }
  makeLabelsForEntry() {
    if (this.entryStatus == 'PENDING')
      this.labels = ['Approve', 'Reject', 'Approve and Shortlist']
    else if (this.entryStatus == 'APPROVED')
      this.labels = ['Reject', 'Approve and Shortlist']
    else if (this.entryStatus == 'REJECTED')
      this.labels = ['Approve']
    else
      this.labels = ['Approve']
  }

  getCompetitionEntries() {
    this.makeLabelsForEntry()
    this.previewImageNumber = 0;
    this.previewImageIndex = 0;
    this.adminService.getCompetitionSubmission(this.competitionId, this.offset, this.totalEntries, this.entryStatus, this.selectedClassFilterCode, this.selectedStateFilterCode).subscribe(
      (res) => {
        this.allEntries = res.submission;
        if (this.allEntries && this.allEntries.length > 0)
          this.previewEntry = this.allEntries[0];
        this.filterStates = res.allowed_filter.state;
        this.filterStates.unshift({ name: "All States", code: "all_states" });
        this.filterClass = res.allowed_filter.grade;
        this.filterClass.unshift({ name: "All Class", value: "all_class" });
      }
    )
  }
  callFilterRefresh() {
    this.getCompetitionEntries();
  }

  triggerFillterButton(selected) {
    this.selectWinner = false;
    let value = "";
    this.previewImageIndex = 0;
    this.previewImageNumber = 0;
    this.selectedEntry = [];
    this.selectedWinnerSubmissionIds = [];
    this.isMultipleSelectOn = false;
    this.selectWinner = false;
    if (selected == 1) {
      value = "PENDING";
      this.emptySvgurl = 'assets/no-entry.svg'
      this.paginationLength = this.pendingCompetition;

    }
    else if (selected == 2) {
      value = "APPROVED"
      this.emptySvgurl = 'assets/no-approved.svg'
      this.paginationLength = this.approvedCompetition;
    }
    else if (selected == 3) {
      value = "REJECTED"
      this.emptySvgurl = 'assets/no-rejected.svg'
      this.paginationLength = this.rejectedCompetition;
    }
    else {
      value = "SHORTLISTED"
      this.emptySvgurl = 'assets/no-shortlist.svg'
      this.paginationLength = this.scheduleCompetition;
    }
    if (value != this.entryStatus) {
      this.entryStatus = value;
      this.previewEntry = undefined;
      this.offset = 0;
      this.paginator.pageIndex = 0;
      this.getCompetitionEntries();
    }
    this.makeLabelsForEntry()
  }
  triggerPreviewEntry(entry, index) {
    this.previewEntry = entry;
    this.previewImageNumber = index;
    this.previewImageIndex = 0;
    this.makeLabelsForEntry()

  }

  previewImagePagination(indexBy) {
    let currIndex = this.previewImageIndex + indexBy;
    if (this.previewEntry?.submission.length > 0 && currIndex >= 0 && currIndex < this.previewEntry?.submission.length) {
      this.previewImageIndex = currIndex;
    }
    this.makeLabelsForEntry()

  }
  changeEntry(indexBy) {
    let currIndex = this.previewImageNumber + indexBy;
    if (this.allEntries && this.allEntries.length > currIndex && currIndex >= 0) {
      this.previewEntry = this.allEntries[currIndex];
      this.previewImageNumber = currIndex;
      this.previewImageIndex = 0;
    }
    this.makeLabelsForEntry();
  }

  changeLabel(event, label) {
    this.selectWinner = false;
    let statusValue;
    if (label == 'Approve')
      statusValue = 'APPROVED';
    else if (label == 'Reject')
      statusValue = 'REJECTED';
    else if (label == 'Approve and Shortlist')
      statusValue = 'APPROVED'

    let shortlist = false;
    if (label == 'Approve and Shortlist') {
      shortlist = true;
    }
    let submission_ids = [this.previewEntry?.submission_uuid];
    if (this.isMultipleSelectOn) {
      submission_ids = [];
      for(let obj of this.selectedEntry){
        submission_ids.push(obj.submission_uuid);
      }
      this.selectedEntry = [];
    }
    const reqBody = {
      submission_uuid_list: submission_ids,
      patch: {
        is_shortlisted: shortlist,
        status: statusValue
      }
    };
    this.adminService.updateSubmissionLabel(reqBody, this.competitionId)
      .subscribe(
        (res) => {
          this.getCompetitionDetails();
          this.getCompetitionEntries();
          this.changeDetectorRef.detectChanges();
        },
        (err) => {
          this.getCompetitionDetails();
          this.getCompetitionEntries();
          this.changeDetectorRef.detectChanges();

        }
      )
  }

  openPreviewPop() {
    const dialogRef = this._matDialog.open(PreviewPopUp, {
      data: { entry: this.previewEntry },
    });
    dialogRef.afterClosed().subscribe((result) => {
    })
  }
  pageEvent: PageEvent;

  handlePageEvent(e: PageEvent) {
    this.offset = e.pageIndex * 9;
    this.getCompetitionEntries();
  }

  selectWinnerToggle() {
    this.selectWinner = !this.selectWinner
  }
  checkSubmissionIdAlreadyPresent(submission_id) {
    let entry = this.selectedEntry.find(obj => obj.submission_uuid === submission_id) || null;
    if (entry) return true;
    else return false;
  }
  selectAllEntries(event: any) {
    const checked = event.target.checked;
    this.selectedEntry = [];
    if (checked) {
        this.allEntries.forEach(entry => {
            entry.selected = checked;
            this.selectedEntry.push(entry);
        });
    } else {
        this.selectedEntry = [];
      }
  } 
  triggerSelectEntry(event, index) {
    let selectedEntryDetail = this.allEntries[index];
     if (this.selectedEntry.includes(selectedEntryDetail)) {
      this.selectedEntry = this.selectedEntry.filter((obj) => obj.submission_uuid != selectedEntryDetail.submission_uuid);
    }
    else {
      this.selectedEntry.push(selectedEntryDetail)
    }
  }
  openDeclareResultPopUp() {
    console.log(this.selectedEntry);
    const dialogRef = this._matDialog.open(DeclareResult, {
      data: { entry: this.selectedEntry, competionDetail: this.competitionDetail, competitionId: this.competitionId },

    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data == 'openReschedule')
        this.sheduledResult();
    })

  }
  sheduledResult() {

    const dialogRef = this._matDialog.open(SheduleDialog, {
      data: { entry: this.selectedEntry, competionDetail: this.competitionDetail, competitionId: this.competitionId },

    });
    dialogRef.afterClosed().subscribe((result) => {

    })


  }


}

@Component({
  selector: 'app-preview-popup',
  templateUrl: './preview-pop.html',
  styleUrls: ['./competition-entry.component.css'],
})
export class PreviewPopUp implements OnInit {
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  previewEntry: any;
  previewImageIndex = 0;

  constructor(public dialogRef: MatDialogRef<PreviewPopUp>, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any, private adminService: AdminService, private _snackBar: MatSnackBar) {
    this.previewEntry = data.entry;
  }



  ngOnInit(): void {

  }
  closePopup() {
    this.dialogRef.close();
  }
  previewImagePagination(index) {
    let newIndex = this.previewImageIndex + index;
    let numberOfPage = this.previewEntry?.submission.length;
    if (newIndex >= 0 && newIndex < numberOfPage) {
      this.previewImageIndex = newIndex;
    }
  }

}


@Component({
  selector: 'app-declare-result-popup',
  templateUrl: './declare-result-popup.html',
  styleUrls: ['./declare-result.css'],
})
export class DeclareResult implements OnInit {
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  topEntry: any;
  previewImageIndex = 0;
  convertedImage: any;
  imageUrl = '';
  certiIndex = 0;
  competitionDetail: any;
  competitionId = '';
  isCertificate = false;
  genratedCertificate = [];
  isLoading = false;
  mode: ProgressSpinnerMode = 'determinate';
  spinnerValue = 0;
  @ViewChild('image-section') imagesection: ElementRef;


  constructor(public dialogRef: MatDialogRef<DeclareResult>, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any, private adminService: AdminService, private _snackBar: MatSnackBar) {
    this.topEntry = data.entry;
    this.competitionDetail = data.competionDetail;
    this.competitionId = data.competitionId;

  }



  ngOnInit(): void {
  }
  closePopup() {
    this.dialogRef.close();
  }
  async dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  }

  handleEvent = null;

  async waitForRendering(index) {
    return new Promise((resolve, reject) => {
      this.handleEvent = (eventData) => {
        if (eventData == index)
          resolve(index);
        else
          reject();
      }
    });
  }
  async generateCertificate(index) {
    this.certiIndex = index;
    try {
      await this.waitForRendering(index);
      let canvas = await html2canvas(document.getElementById("certificate"), {
        allowTaint: true,
        useCORS: true
      })
      this.handleEvent = null;
      const dataUrl = canvas.toDataURL("image/png");
      this.convertedImage = await this.dataURItoBlob(dataUrl);
      this.convertedImage.lastModifiedDate = new Date();
      this.convertedImage.name = `${this.topEntry[index].user_name}-certificate`;
      this.imageUrl = dataUrl;
      const res = await this.adminService.getS3DetailsAndUpload(this.convertedImage, 'certificate', this.competitionId).toPromise();
      let certificate_uuid = res.certificate_uuid;
      await this.adminService.uploadImageToS3(this.convertedImage, res).toPromise();
      this.topEntry[index]['certificate_uuid'] = certificate_uuid;
      this.genratedCertificate.push(certificate_uuid);
      return true;
    } catch (err) {
      this._snackBar.open('Something Went Wrong', 'close', {
        duration: 3000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
      });
      return false;
    }
  }
  leftOut(first, second) {
    if ((first == 0 && second == 1) || (first == 1 && second == 0)) return 2;
    if ((first == 1 && second == 2) || (first == 2 && second == 1)) return 0;
    if ((first == 0 && second == 2) || (first == 2 && second == 0)) return 1;
  }
  suffleEntry(first, second) {

    if (this.genratedCertificate.length >= 2) {
      return;
    }
    if (this.genratedCertificate.length == 1) {
      if (this.topEntry[first].certificate_uuid) first = this.leftOut(first, second);
      if (this.topEntry[second].certificate_uuid) second = this.leftOut(first, second);
    }
    const temperory = this.topEntry[first];
    this.topEntry[first] = this.topEntry[second];
    this.topEntry[second] = temperory;
  }
  submitWinnerandReshedule() {
    this.adminService.submitWinners(this.topEntry, this.competitionId).subscribe(
      (res) => {
        this.dialogRef.close({ event: 'close', data: 'openReschedule' });
      },
      (err) => {
        if (err.error.message) {
          this._snackBar.open(err.error.message, 'close', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
          });
          this.dialogRef.close();
        }
        else {
          this.dialogRef.close({ event: 'close', data: 'openReschedule' });
        }
      }

    );
  }
  async generateAllCertificate() {
    this.spinnerValue += 30;
    for (let index = 0; index < 3; index++) {
      const isConversionSuccess = await this.generateCertificate(index);
      if (!isConversionSuccess) {
        this.spinnerValue = 0;
        this.dialogRef.close();
        return;
      }
      this.spinnerValue += 20;

    }
    this.submitWinnerandReshedule()
    this.spinnerValue = 100;

  }

}



@Component({
  selector: 'app-scedule-dialog',
  templateUrl: './schedule-result.html',
  styleUrls: ['./competition-entry.component.css']
})

export class SheduleDialog implements OnInit {
  title: string = "";
  minDate: Date;
  maxDate: Date;
  times: string[] = ["09:00 am", "12:00 pm", "03:00 pm", "06:00 pm"];
  selected: string;
  date = new FormControl();
  intialDate = "";
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  @Input() winnerEntries: any;
  @Input() competitionId: any;
  constructor(public dialogRef: MatDialogRef<SheduleDialog>,public dialogRef1: MatDialogRef<DeclareResult>, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any, private adminService: AdminService, private _snackBar: MatSnackBar) {
    this.date.setValue(new Date());
    this.intialDate = data.dateTime
    this.minDate = new Date();
    this.selected = "";
  }


  constructTimeFromTimeStamp(time) {
    const date = new Date(time);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 || 12;
    const formattedTime = `${formattedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    return formattedTime;
  }


  ngOnInit(): void {
  }
  closePopup() {
    this.dialogRef.close();
  }

  validateTime() {
    const dateValue = new Date(this.date.value);
    const timeValue = this.selected;
    let [hours, minutes] = timeValue.split(':');
    const isPM = timeValue.toLowerCase().includes('pm');

    if (isPM && hours !== '12') {
      hours = String(parseInt(hours, 10) + 12);
    }

    dateValue.setHours(parseInt(hours, 10), parseInt(minutes, 10));

    const formattedDate = dateValue.toISOString();
    let current_time = new Date().getTime();
    let schedule_time = new Date(formattedDate).getTime();
    if (formattedDate == this.intialDate) {
      this._snackBar.open('Nothing Changed', 'close', {
        duration: 3000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
      });
      return false;
    } else if (schedule_time < current_time) {
      this._snackBar.open('Time Already Passed', 'close', {
        duration: 3000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
      });
      return false;

    }
    return true;
  }
  declareResult() {
    if (!this.validateTime()) return;
    let entries = this.winnerEntries.map(obj => obj.submission_uuid);
    this.adminService.submitWinners(entries, this.competitionId).subscribe(
      (res) => {
        this.resheduleDateTime();
      },
      (err) => {
        if (err.status == 200) {
          this.resheduleDateTime();
        } else {
          this._snackBar.open(err.error.message, 'close', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
          });
        }
      }
    );
  }
  resheduleDateTime() {
    const dateValue = new Date(this.date.value);
    const timeValue = this.selected;
    let [hours, minutes] = timeValue.split(':');
    const isPM = timeValue.toLowerCase().includes('pm');

    if (isPM && hours !== '12') {
      hours = String(parseInt(hours, 10) + 12);
    }

    dateValue.setHours(parseInt(hours, 10), parseInt(minutes, 10));

    const formattedDate = dateValue.toISOString();
    this.adminService.scheduleResult(formattedDate, this.competitionId).subscribe(
      (res) => {
        this._snackBar.open("Successfully Result Scheduled", 'close', {
          duration: 3000,
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition,
        });
        this.router.navigateByUrl('/admin/social-hub/competition-zone');
        this.dialogRef1.close();

      },
      (err) => {
        if (err.status == 200) {
          this._snackBar.open("Successfully Result Scheduled", 'close', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
          });
          this.router.navigateByUrl('/admin/social-hub/competition-zone');
          this.dialogRef1.close();

        } else {
          this._snackBar.open(err.err.message, 'close', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
          });
        }
      }
    )

    // this._snackBar.open("Successfully Result Scheduled", 'close', {
    //   duration: 3000,
    //   horizontalPosition: this.horizontalPosition,
    //   verticalPosition: this.verticalPosition,
    // });
    // this.router.navigateByUrl('/admin/social-hub/competition-zone');
    // this.dialogRef.close({
    //   event: 'close',
    //   data: {
    //     updatedTime: formattedDate
    //   }
    // })

  }

}





